import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { RequestSubCategoryDto, RequestCategoryDto } from '@cradua/data';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
    selector: 'cradua-requestsubcategory',
  templateUrl: './requestsubcategory.component.html',
  styleUrls: ['./requestsubcategory.component.scss']
})
export class RequestSubCategoryComponent implements OnChanges {

  @Input() requestsubcategorys: RequestSubCategoryDto[];
  @Input() requestcategorys: RequestCategoryDto[];
  requestsubcategoryForm: FormGroup;
  requestsubcategoryFormArray: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<RequestSubCategoryDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  filteredDelete: Array<any> = [];
  filteredRequestSubCategory: Array<any> = [];
  status: boolean;
  selectedRequestSubCategoryId: any;
  selectedIndex = null;

  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createRequestSubCategoryForm();
  }

  createRequestSubCategoryForm() {
    this.requestsubcategoryFormArray = this.fb.group({ RequestSubCategorys: this.fb.array([]) });
    this.requestsubcategoryForm = this.fb.group({
      RequestSubCategoryName: ['', Validators.required],
        RequestCategoryId: this.selectedRequestSubCategoryId,
        id: null
    });
  }


  // method to display companies
  setRequestSubCategory() {
    const control = this.requestsubcategoryFormArray.controls.RequestSubCategorys as FormArray;
    this.filteredRequestSubCategory.forEach((e) => {
      control.push(
        this.fb.group({
          RequestSubCategoryName: e.RequestSubCategoryName,
          RequestCategoryId: e.RequestCategoryId,
          id: e.id,
        })
      );
    });
  }

   // method to add Company
   addRequestSubCategory(requestsubcategory: RequestSubCategoryDto) {
    console.log('requestsubcategory');
    const control = this.requestsubcategoryFormArray.controls.RequestSubCategorys as FormArray;
    control.insert(
      0,
      this.fb.group({
        RequestSubCategoryName: requestsubcategory.RequestSubCategoryName,
        RequestCategoryId: this.selectedRequestSubCategoryId,

      })
    );
  }


  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.requestsubcategoryFormArray.controls.RequestSubCategorys as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter requestsubcategory
  selectRequestCategory(event: string) {
    this.filteredRequestSubCategory = this.requestsubcategorys.filter((s) => s.RequestCategoryId === event);
    this.selectedRequestSubCategoryId = event;
    const control = this.requestsubcategoryFormArray.controls.RequestSubCategorys as FormArray;

    if (this.filteredRequestSubCategory.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setRequestSubCategory();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  print(event: any) {
    window.print();
  }
  // method to delete company from arrary list
  deleteRequestSubCategory(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.requestsubcategoryFormArray.controls.RequestSubCategorys as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.requestsubcategorys.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.requestsubcategorys[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }


  addNew(formValue: RequestSubCategoryDto) {
    if(this.requestsubcategoryForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.requestsubcategoryFormArray.get('RequestSubCategorys')['controls'][this.selectedIndex].patchValue({RequestSubCategoryName: formValue.RequestSubCategoryName});
    } else {
      this.addRequestSubCategory(formValue);
    }
    this.selectedIndex = null;
    this.requestsubcategoryForm.reset()
  }

  onEdit(index, value: RequestSubCategoryDto) {
    this.selectedIndex = index;
    this.requestsubcategoryForm.patchValue({RequestSubCategoryName: value.RequestSubCategoryName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.requestsubcategoryForm.reset();
  }


  onSubmit(formValue: any) {
    formValue.type = 'requestsubcategory';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length > 0) {
      this.filteredDelete.unshift('requestsubcategory');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }

}
